<template lang="pug">
  section
    EditDialog(ref="EditDialog" title="仮受注" @delete="erase" @save="savePreFlight" :recordId="record.id"
      width="80%"
      :displayDeleteButton="canEditData" :enableSave="canEditData"
      :loadingSave="loading.save" :loadingDelete="loading.delete"
      @closeEditDialog="closeEditDialog")
      template(v-slot:body)
        v-container(grid-list-md)
          v-layout(row wrap)
            // 荷主
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              ClientSelect(:label.sync="record.clientName" :code.sync="record.clientId"
                :errorHandlerMethod="getErrorMessages" :errorHandlerMethodArg="'clientId'")
            v-flex(xs12 md3 v-else)
              v-text-field(readonly box label="荷主" v-model="record.clientName")

            // 請求区分
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              BillingTypeSelect(:code.sync="record.billingTypeId" :errorHandlerMethod="getErrorMessages" clearable)
            v-flex(xs12 md3 v-else)
              v-text-field(readonly box label="請求区分" v-model="record.billingTypeName")

            // 距離区分
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              DistanceTypeSelect(:code.sync="record.distanceType" :errorHandlerMethod="getErrorMessages" clearable)
            v-flex(xs12 md3 v-else)
              v-select(readonly box v-model="record.distanceType" :items="distanceTypes"
                item-text="label" item-value="code" label="距離区分")

            // 荷主枝番
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              ClientBranchSelect(:clientId="record.clientId" :clientBranchId="record.clientBranchId" clearable
                :code.sync="record.clientBranchId" @updateLabel="value => record.clientBranchName = value"
                :errorHandlerMethod="getErrorMessages")
            v-flex(xs12 md3 v-else)
              v-text-field(readonly box label="荷主枝番" v-model="record.clientBranchName")

            //積地メモ
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              v-text-field(v-model="record.loadingBaseMemo" label="積地メモ" clearable
                :error-messages="getErrorMessages('loadingBaseMemo')")
            v-flex(xs12 md3 v-else)
              v-text-field(readonly box label="積地メモ" v-model="record.loadingBaseMemo")

            v-flex(xs12 md3)
              AreaSelect(:label.sync="record.loadingBaseMemoAreaName" :code.sync="record.loadingBaseMemoAreaId"
                title="積地メモエリア" clearable
                :errorHandlerMethod="getErrorMessages" :errorHandlerMethodArg="'loadingBaseMemoAreaId'")

            //卸地メモ
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              v-text-field(v-model="record.unloadingBaseMemo" label="卸地メモ" clearable
                :error-messages="getErrorMessages('unloadingBaseMemo')")
            v-flex(xs12 md3 v-else)
              v-text-field(readonly box label="卸地メモ" v-model="record.unloadingBaseMemo")

            v-flex(xs12 md3)
              AreaSelect(:label.sync="record.unloadingBaseMemoAreaName" :code.sync="record.unloadingBaseMemoAreaId"
                title="卸地メモエリア" clearable
                :errorHandlerMethod="getErrorMessages" :errorHandlerMethodArg="'unloadingBaseMemoAreaId'")

            // 受注日
            v-flex(xs12 md3)
              DatePicker(:isReadonly="isDispatchedOrder || !canEditData" pickerLabel="受注日"
                :initDate.sync="getInitOrderDate" :inputDate.sync="record.orderDate"
                :errorHandlerMethod="getErrorMessages" errorHandlerMethodParam="orderDate")

            // 仮受付番号
            v-flex(xs12 md3 v-if="record.provisionalOrderDetailNo")
              v-textarea(label="仮受付番号" :value="record.provisionalOrderDetailNo" auto-grow box readonly hide-details rows="1")

          v-layout(row wrap)

            // 積込予定日(from)
            v-flex(xs12 md3)
              DatePicker(:isReadonly="isDispatchedOrder || !canEditData" pickerLabel="積込予定日(from)"
                :initDate.sync="getInitLoadingDate" :inputDate.sync="record.loadingDateFrom"
                :errorHandlerMethod="getErrorMessages" :errorHandlerMethodParam="'loadingDateFrom'")

            // 積込予定日(to)
            v-flex(xs12 md3)
              DatePicker(:isReadonly="isDispatchedOrder || !canEditData" pickerLabel="積込予定日(to)"
                :initDate.sync="getInitLoadingDate" :inputDate.sync="record.loadingDateTo"
                :errorHandlerMethod="getErrorMessages" :errorHandlerMethodParam="'loadingDateTo'")

            // 納品予定日(from)
            v-flex(xs12 md3)
              DatePicker(:isReadonly="isDispatchedOrder || !canEditData" pickerLabel="納品予定日(from)"
                :initDate.sync="getInitUnloadingDate" :inputDate.sync="record.unloadingDateFrom"
                :errorHandlerMethod="getErrorMessages" :errorHandlerMethodParam="'unloadingDateFrom'")

            // 納品予定日(to)
            v-flex(xs12 md3)
              DatePicker(:isReadonly="isDispatchedOrder || !canEditData" pickerLabel="納品予定日(to)"
                :initDate.sync="getInitUnloadingDate" :inputDate.sync="record.unloadingDateTo"
                :errorHandlerMethod="getErrorMessages" :errorHandlerMethodParam="'unloadingDateTo'")



            // 車格積載重量
            v-flex(xs12 md5)
              VehicleCarryWeightSelect(:isReadonly="isDispatchedOrder || !canEditData"
                :label.sync="record.carryWeight"
                @setSelectData="selectVehicleType"
                :code.sync="record.vehicleCarryWeightId"
                :selectVehicleTypeId.sync="record.vehicleTypeId"
                :vehicleTypeName="record.vehicleTypeName" :errorHandlerMethod="getErrorMessages")

            //台数
            v-flex(xs12 md1 v-if="!record.id")
              v-text-field.text-align-right(v-model="record.vehicleQuantity" label="台数"
                :error-messages="getErrorMessages('vehicleQuantity')")

            //積荷種別
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              ItemTypeSelect(:label.sync="record.itemTypeName" :code.sync="record.itemTypeId"
                :errorHandlerMethod="getErrorMessages" :errorHandlerMethodArg="'itemTypeId'")
            v-flex(xs12 md3 v-else)
              v-text-field(readonly box label="積荷種別" v-model="record.itemTypeName")

            //積荷重量
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              v-text-field.text-align-right(v-model="record.weight" @blur="addComma" label="積荷重量（１台あたり）"
                :error-messages="getErrorMessages('weight')" suffix="kg")
            v-flex(xs12 md3 v-else)
              v-text-field.text-align-right(readonly box v-model="record.weight" @blur="addComma" label="積荷重量（１台あたり）" :error-messages="getErrorMessages('weight')" suffix="kg")

            //荷役区分
            v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
              HandlingUnitTypeSelect(:code.sync="record.handlingUnitType" :errorHandlerMethod="getErrorMessages")
            v-flex(xs12 md3 v-else)
              v-select(readonly box v-model="record.handlingUnitType" :items="handlingUnitTypes" item-text="label" item-value="code" label="荷役区分")

            //配車カードマーク
            v-flex(xs12 md3)
              CardMarkSelect(:code.sync="record.markType" :errorHandlerMethod="getErrorMessages")

            //手配フラグ
            v-flex(xs12 md3)
              v-checkbox(:disabled="isDispatchedOrder || !canEditData" v-model="record.arrangeFlg"
                label="手配済み")



          //積地卸地用
          v-layout(row wrap)
            v-flex(xs12)
              v-alert(type="warning" :value="true" v-show="!canSelectBase") 積地・卸地の設定をするには荷主と荷主枝番を選択してください。
              v-card(v-show="canSelectBase")
                v-card-text
                  v-container(grid-list-md)
                    div(v-for="(loading, index) in record.loadingBaseList")
                      v-layout(row wrap)
                        //積地
                        v-flex(xs12 md12 v-if="!isDispatchedOrder && canEditData")
                          LoadingBaseSelect(:excludeBaseIdList="loadingBaseIdList" :clientId="record.clientId"
                            :clientBranchId="record.clientBranchId" :enableDelete="(index == 0 ? false :true)"
                            :label.sync="loading.nameAndCd" :code.sync="loading.baseId"
                            :errorHandlerMethod="getErrorMessages"
                            :errorHandlerMethodArg="'loadingBaseList[' + index + '].baseId'"
                            @deleteList="deleteLoadingBaseList(index)"
                            @setSelectData="data => selectLoadingBase(loading,data)")
                        v-flex(xs12 md12 v-else)
                          v-text-field(readonly box label="積地" v-model="loading.nameAndCd")

                    v-layout(row wrap)
                      v-flex(xs12 md6)
                      v-icon keyboard_arrow_down

                    div(v-for="(unloading, index) in record.unloadingBaseList")
                      v-layout(row wrap)
                        //卸地
                        v-flex(xs12 md4 v-if="!isDispatchedOrder && canEditData")
                          UnloadingBaseSelect(:excludeBaseIdList="unloadingBaseIdList" :clientId="record.clientId"
                            :clientBranchId="record.clientBranchId" :enableDelete="(index == 0 ? false :true)"
                            :label.sync="unloading.nameAndCd" :code.sync="unloading.baseId"
                            :errorHandlerMethod="getErrorMessages"
                            :errorHandlerMethodArg="'unloadingBaseList[' + index + '].baseId'"
                            @deleteList="deleteUnloadingBaseList(index)"
                            @setSelectData="data => selectUnloadingBase(unloading, data)")
                        v-flex(xs12 md4 v-else)
                          v-text-field(readonly box label="卸地" v-model="unloading.nameAndCd")

                        //時間指定(開始)
                        v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
                          TimePicker(pickerLabel="時間指定(開始)" :initTime="null" :inputTime.sync="unloading.specifiedTimeFrom"
                            :errorHandlerMethod="getErrorMessages"
                            :errorHandlerMethodParam="'unloadingBaseList[' + index + '].specifiedTimeFrom'" )
                        v-flex(xs12 md3 v-else)
                          v-text-field(readonly box label="時間指定(開始)" v-model="unloading.specifiedTimeFrom")
                        //時間指定(終了)
                        v-flex(xs12 md3 v-if="!isDispatchedOrder && canEditData")
                          TimePicker(pickerLabel="時間指定(終了)" :initTime="null" :inputTime.sync="unloading.specifiedTimeTo"
                            :errorHandlerMethod="getErrorMessages"
                            :errorHandlerMethodParam="'unloadingBaseList[' + index + '].specifiedTimeTo'" )
                        v-flex(xs12 md3 v-else)
                          v-text-field(readonly box label="時間指定(終了)" v-model="unloading.specifiedTimeTo")

                        v-flex(xs12 md2 v-if="!isDispatchedOrder && canEditData")
                          v-text-field.text-align-right(label="卸順序" v-model="unloading.unloadingOrder",
                            :error-messages="getErrorMessages('unloadingBaseList[' + index + '].unloadingOrder')")
                        v-flex(xs12 md2 v-else)
                          v-text-field.text-align-right(readonly box label="卸順序" v-model="unloading.unloadingOrder")

                    v-btn(v-if="!isDispatchedOrder" color="info" falt @click.stop="addLoadingBase"
                      v-bind:disabled ="loadingBaseLimit") 積地を追加する
                    v-btn(v-if="!isDispatchedOrder" color="info" falt @click.stop="addUnloadingBase"
                      v-bind:disabled ="unloadingBaseLimit") 卸地を追加する

          // 受注希望者欄
          v-layout(row wrap v-if="record.id")
            v-flex(xs12 md3)
              // 仮受注状態
              v-text-field(:value="getProvisionalOrderStatusTypeLabel(record.provisionalOrderStatus)"
                label="仮受注状態" readonly box)
            v-flex(xs12 md9)
              v-btn(color="warning" v-if="canChangeLostOrderStatus" @click="openOrderLossConfirmDialog") 失注登録する
              v-btn(color="primary" v-if="canCancelLostOrderStatus" @click="openLostOrderCancelConfirmDialog") 失注をキャンセルする

              v-btn(color="primary" v-if="isDisplayChangeCreatingOrderStatus" @click="openCreatingOrderConfirmDialog") 受注登録中に変更する
              v-btn(color="warning" v-if="isDisplayCancelCreatingOrderStatus" @click="openCreatingOrderCancelConfirmDialog") 受注登録中をキャンセルする
            v-flex(xs12 v-if="record.applicantList != null && record.applicantList.length > 0")
              ApplicantList(:list="record.applicantList")

          v-layout(row wrap v-if="isLostOrderCancelable")
            v-flex(xs12)
              v-card
                v-card-text
                  v-layout(row wrap)
                    v-flex(xs12 md3)
                      //失注理由
                      OrderLossStatusSelect(:code.sync="record.lostOrderReason" :multiple="false" :clearable="false")
                    v-flex(xs12)
                      //失注理由その他
                      v-textarea(label="失注理由その他" auto-grow v-model="record.lostOrderReasonOther" :error-messages="getErrorMessages('lostOrderReasonOther')")

          //積地卸地用
          v-layout(row wrap)
            v-flex(xs12)
              v-card
                v-card-text
                  v-container(grid-list-md)
                    v-layout(row wrap)
                      v-flex(xs12)
                        v-card
                          v-card-text
                            v-layout(row wrap)
                              v-flex(xs8)
                                BillingCardBasicPriceBox
                              v-flex(xs4 v-if="canEditData")
                                template(v-for="(billing,index) in billingCardDetail" v-if="billing.billingItemId === 1")
                                  DigitSeparatorsField(:readOnly="!canEditData" v-model="billing.billingItemPrice" :label="billing.billItemName"
                                    :errorMessages="getErrorMessages('billingCard.billingCardDetails[' + index + '].billingItemPrice')")
                              v-flex(xs4 v-else)
                                template(v-for="(billing,index) in billingCardDetail" v-if="billing.billingItemId === 1")
                                  v-text-field.text-align-right(readonly box :label="billing.billItemName"  :value="billing.billingItemPrice|addComma" @input="value=>billing.billingItemPrice=value")

                    v-layout(row wrap)
                      template(v-for="(billing,index) in billingCardDetail"  v-if="billing.billingItemId !== 1")
                        v-flex(xs3 v-if="canEditData")
                          DigitSeparatorsField(:readOnly="!canEditData" v-model="billing.billingItemPrice" :label="billing.billItemName"
                            :errorMessages="getErrorMessages('billingCard.billingCardDetails[' + index + '].billingItemPrice')")
                        v-flex(md3 v-else)
                          v-text-field.text-align-right(readonly box :label="billing.billItemName" :value="billing.billingItemPrice|addComma" @input="value=>billing.billingItemPrice=value")

                    v-layout(row wrap)
                      v-flex(xs12)
                        table.finance-summary-table
                          tr
                            th 通行料
                            td
                              DigitSeparatorsLabel(:value="billingCardToll").price
                            th 運賃料金計
                            td
                              DigitSeparatorsLabel(:value="billingCardSummaryWithoutToll").price

            // 備考、会計備考、配車メモ
            v-flex(xs12)
              v-textarea(:readOnly="!canEditData" :box="!canEditData" label="備考" auto-grow v-model="record.remark"
                :error-messages="getErrorMessages('remark')")
              v-textarea(:readOnly="!canEditData" :box="!canEditData" label="会計備考" auto-grow v-model="record.financeRemark"
                :error-messages="getErrorMessages('financeRemark')")
              v-textarea(:readOnly="!canEditData" :box="!canEditData" label="配車メモ" auto-grow v-model="record.dispatchMemo"
                :error-messages="getErrorMessages('dispatchMemo')")

      template(v-slot:footer="slotProps")
        v-layout(row wrap)
          v-flex(xs12 md4)
            v-btn(color="error" @click="slotProps.deleteConfirm" v-if="canDeleteProvisionalCard" :loading="loading.delete") 削除

          v-flex(xs12 md4 text-xs-center)
            v-btn(color="success" @click="openGeneralOrderEditDialog" v-if="canConfirmProvisionalOrder") 正式受注登録
            v-btn(color="info" @click="openOrderRequestConfirmDialog" v-if="canAddApplicant") 受注希望依頼
            v-btn(color="warning" @click="openOrderRequestCancelConfirmDialog" v-if="canRemoveApplicant") 受注希望キャンセル

          v-flex(xs12 md4 text-xs-right)
            v-btn(color="primary" @click="slotProps.saveRecord" :loading="loading.save" ) 保存
    FinanceOverrideWarningDialog(ref="FinanceOverrideWarningDialog" @yes="saveAndClose" )
    ManualOrderHistoryDialog(ref="ManualOrderHistoryDialog")
    // 失注保存の確認ダイアログ
    ProvisionalOrderLossConfirmDialog(ref="ProvisionalOrderLossConfirmDialog" :provisional-order-card-id="record.id"
    :post-url="$config.urls.postProvisionOrderLoss" @saved="onSavedLostOrderStatus"
    )

    // 受注希望確認ダイアログ
    ConfirmDialog(ref="orderRequestConfirm" message="受注希望依頼を出しますか？" title="受注希望確認" @yes="executeOrderApplicantRequest")
    // 受注希望キャンセル確認ダイアログ
    ConfirmDialog(ref="orderRequestCancelConfirm" message="受注希望依頼をキャンセルしますか？" title="受注希望キャンセル確認" @yes="executeOrderApplicantCancelRequest")
    // 正式受注登録確認ダイアログ
    ConfirmDialog(ref="orderFormalConfirm" message="正式に受注登録しますか？" title="正式受注登録確認" @yes="executeOrderFormalRequest")
    // 失注のキャンセル確認ダイアログ
    ConfirmDialog(ref="lostOrderCancelConfirm" message="失注をキャンセルして仮受注に戻しますか？" title="失注キャンセル確認" @yes="executeOrderLossCancelRequest")
    // 受注登録中確認ダイアログ
    ConfirmDialog(ref="creatingOrderConfirm" message="受注登録中に変更しますか？" title="受注登録中確認" @yes="executeCreatingOrderRequest")
    // 受注登録中キャンセル確認ダイアログ
    ConfirmDialog(ref="creatingOrderCancelConfirm" message="受注登録中をキャンセルしますか？" title="受注登録中キャンセル確認" @yes="executeCreatingOrderCancelRequest")
</template>

<script>
import EditDialog from "@/components/common/dialog/EditDialog";
import TimePicker from "@/components/common/TimePicker";
import DatePicker from "@/components/common/DatePicker";
import ClientSelect from "@/components/common/select/ClientSelect";
import ClientBranchSelect from "@/components/common/select/ClientBranchSelect";
import BillingTypeSelect from "@/components/common/select/BillingTypeSelect";
import DistanceTypeSelect from "@/components/common/select/DistanceTypeSelect";
import VehicleCarryWeightSelect from "@/components/common/select/VehicleCarryWeightSelect";
import ItemTypeSelect from "@/components/common/select/ItemTypeSelect";
import HandlingUnitTypeSelect from "@/components/common/select/HandlingUnitTypeSelect";
import LoadingBaseSelect from "@/components/common/select/LoadingBaseSelect";
import UnloadingBaseSelect from "@/components/common/select/UnloadingBaseSelect";
import SpecifiedTimeTypeIcon from "@/components/common/SpecifiedTimeTypeIcon";
import DigitSeparatorsField from "@/components/common/DigitSeparatorsField";
import DigitSeparatorsLabel from "@/components/common/DigitSeparatorsLabel";
import BillingCardBasicPriceBox from "@/components/finance/BillingCardBasicPriceBox";
import FinanceOverrideWarningDialog from "@/components/common/dialog/FinanceOverrideWarningDialog";
import ConfirmDialog from "@/components/common/dialog/ConfirmDialog.vue";
import * as Enum from "@/assets/js/enum";

import { LabelName } from "@/assets/js/constants";
import { mapActions, mapGetters } from "vuex";
import ManualOrderHistoryDialog from "@/components/order/ManualOrderHistoryDialog.vue";
import { useApiHandler } from "@/composables/api/useApiHandler";
import { useProvisionalOrder } from "@/composables/order/useProvisionalOrder";
import { getCurrentInstance, ref } from "vue";
import OrderLossStatusSelect from "@/components/common/select/OrderLossStatusSelect.vue";
import ProvisionalOrderLossConfirmDialog from "@/components/common/dialog/ProvisionalOrderLossConfirmDialog.vue";
import AreaSelect from "@/components/common/select/AreaSelect.vue";
import CardMarkSelect from "@/components/common/select/CardMarkSelect.vue";
import ApplicantList from "@/components/provisional-order/ApplicantList.vue";

export default {
  setup(props, { emit }) {
    const vm = getCurrentInstance();
    const store = vm.proxy.$store;

    const { initData } = useProvisionalOrder();
    const record = ref(initData());

    const {
      setTranData,
      canSelectBase,
      loadingBaseIdList,
      unloadingBaseIdList,
      loadingBaseLimit,
      unloadingBaseLimit,
      isDispatchedOrder,
      canDisplayBillingData,
      canEditData,
      isSettingKey,
      addLoadingBase,
      addUnloadingBase,
      clearLoadingBaseList,
      clearUnloadingBaseList,
      setInitDate,
      getInitOrderDate,
      getInitLoadingDate,
      getInitUnloadingDate,
      triggerCalcBasicPrice,
      selectLoadingBase,
      selectUnloadingBase,
      selectVehicleType,
      closeEditDialog,
      deleteLoadingBaseList,
      deleteUnloadingBaseList,
      initializeFormData,
      isLostOrderRegisterable,
      isLostOrderCancelable,
      canEditProvisionalOrderCard,
      canDeleteProvisionalCard,
      isDisplayChangeCreatingOrderStatus,
      isDisplayCancelCreatingOrderStatus,
      canChangeLostOrderStatus,
      canCancelLostOrderStatus,
      canAddApplicant,
      canRemoveApplicant,
      canConfirmProvisionalOrder
    } = useProvisionalOrder(record, store);

    const provisionalOrderStatus = Enum.ProvisionalOrderStatusType;

    const { saveRecord, deleteRecord, setErrorMessages, getErrorMessages, clearErrorMessages, loading } =
      useApiHandler(
        props.postUrl,
        props.deleteUrl,
        (response, data) => {
          emit("updated", response, data);
        },
        response => {
          emit("deleted", response);
        }
      );

    const distanceTypes = Enum.Utils.enumToList(Enum.DistanceType);
    const handlingUnitTypes = Enum.Utils.enumToList(Enum.HandlingUnitType);

    return {
      provisionalOrderStatus,
      saveRecord,
      deleteRecord,
      setErrorMessages,
      getErrorMessages,
      clearErrorMessages,
      loading,
      initData,
      record,

      loadingBaseIdList,
      unloadingBaseIdList,
      loadingBaseLimit,
      unloadingBaseLimit,
      isDispatchedOrder,

      canDisplayBillingData,
      canEditData,
      isSettingKey,
      distanceTypes,
      handlingUnitTypes,
      canSelectBase,
      addLoadingBase,
      addUnloadingBase,

      setInitDate,
      getInitOrderDate,
      getInitLoadingDate,
      getInitUnloadingDate,
      clearLoadingBaseList,
      clearUnloadingBaseList,
      triggerCalcBasicPrice,

      selectLoadingBase,
      selectUnloadingBase,
      selectVehicleType,
      closeEditDialog,
      deleteLoadingBaseList,
      deleteUnloadingBaseList,
      initializeFormData,
      setTranData,
      isLostOrderRegisterable,
      isLostOrderCancelable,

      canDeleteProvisionalCard,
      isDisplayChangeCreatingOrderStatus,
      isDisplayCancelCreatingOrderStatus,
      canChangeLostOrderStatus,
      canCancelLostOrderStatus,
      canAddApplicant,
      canRemoveApplicant,
      canEditProvisionalOrderCard,
      canConfirmProvisionalOrder
    };
  },
  components: {
    ApplicantList,
    CardMarkSelect,
    AreaSelect,
    ProvisionalOrderLossConfirmDialog,
    OrderLossStatusSelect,
    ManualOrderHistoryDialog,
    SpecifiedTimeTypeIcon,
    EditDialog,
    TimePicker,
    DatePicker,
    ClientSelect,
    ClientBranchSelect,
    BillingTypeSelect,
    DistanceTypeSelect,
    VehicleCarryWeightSelect,
    ItemTypeSelect,
    HandlingUnitTypeSelect,
    LoadingBaseSelect,
    UnloadingBaseSelect,
    DigitSeparatorsField,
    DigitSeparatorsLabel,
    BillingCardBasicPriceBox,
    FinanceOverrideWarningDialog,
    ConfirmDialog
  },
  props: {
    callBackAfterOpenDialog: {
      type: Function,
      default: () => {},
      required: false
    },
    postUrl: {
      type: String,
      default() {
        return this.$config.urls.postProvisionalOrderEdit;
      }
    },
    deleteUrl: {
      type: String,
      default() {
        return this.$config.urls.deleteProvisionalOrder;
      }
    }
  },
  data() {
    return {
      labelName: LabelName
    };
  },
  computed: {
    /** Getter：Vuex */
    ...mapGetters({
      billingCard: "finance/billingCard",
      billingCardDetail: "finance/billingCardDetail",
      billingCardToll: "finance/billingCardToll",
      billingCardSummaryWithoutToll: "finance/billingCardSummaryWithoutToll"
    })
  },
  methods: {
    ...mapActions("provisionalOrder", {
      postOrderApplicantRequest: "postOrderApplicantRequest",
      postOrderApplicantCancel: "postOrderApplicantCancel"
    }),
    /**
     * カンマフィルタ呼び出し
     */
    addComma(value) {
      const cleanValue = value.target.value.replace(/,/g, "");
      this.record.weight = cleanValue === "" ? null : this.$options.filters.addComma(cleanValue);
    },
    /**
     * フォームの初期化
     * @param values
     */
    async initForm(values) {
      await this.initializeFormData(values);
      this.callBackAfterOpenDialog();
    },
    openDeleteConfirmDialog() {
      this.$refs.DeleteConfirmDialog.openDialog();
    },
    openDialog(item) {
      this.clearErrorMessages();
      this.initForm(item);
      this.$refs.EditDialog.openDialog();
    },
    closeDialog() {
      this.$refs.EditDialog.closeDialog();
    },
    savePreFlight() {
      const data = this.setTranData();
      if (this.record.copy) {
        this.$refs.FinanceOverrideWarningDialog.checkEditableFinanceInfo(null);
      } else {
        this.$refs.FinanceOverrideWarningDialog.checkEditableFinanceInfo(data.cardId);
      }
    },
    async save(options = {}) {
      const res = await this.saveRecord(this.setTranData(), this.postUrl, options).catch(error => {
        this.openErrorMsgBox(error.response.data.message);
        return Promise.reject(error);
      });

      // 保存時に、更新日時があるときは画面上のデータを更新しておく（排他でひっかかるので）
      if (res.data.data.updatedAt) {
        this.record.updatedAt = res.data.data.updatedAt;
      }
    },
    async saveAndClose() {
      await this.save();
      this.$refs.EditDialog.closeDialog();
    },
    erase() {
      const self = this;
      this.deleteRecord(this.record.id).then(() => {
        self.closeDialog();
      });
    },
    openErrorMsgBox(message) {
      this.$refs.EditDialog.openErrorMsgBox(message);
    },
    openBillingHistory() {
      this.$refs.ManualOrderHistoryDialog.openDialog();
    },

    /**
     * 受注希望確認ダイアログを開きます。
     */
    openOrderRequestConfirmDialog() {
      this.$refs.orderRequestConfirm.openDialog();
    },
    /**
     * 受注希望キャンセル確認ダイアログを開きます。
     */
    openOrderRequestCancelConfirmDialog() {
      this.$refs.orderRequestCancelConfirm.openDialog();
    },
    /**
     * 失注確認ダイアログを開きます。
     */
    openOrderLossConfirmDialog() {
      this.$refs.ProvisionalOrderLossConfirmDialog.openDialog();
    },
    /**
     * 失注キャンセル確認ダイアログを開きます。
     */
    openLostOrderCancelConfirmDialog() {
      this.$refs.lostOrderCancelConfirm.openDialog();
    },

    openCreatingOrderConfirmDialog() {
      this.$refs.creatingOrderConfirm.openDialog();
    },
    openCreatingOrderCancelConfirmDialog() {
      this.$refs.creatingOrderCancelConfirm.openDialog();
    },

    /**
     * 受注希望リクエストを送信する。
     */
    executeOrderApplicantRequest() {
      const self = this;
      this.postOrderApplicantRequest({
        provisionalOrderCardId: this.record.id
      }).then(value => {
        self.initForm(value.data.data);
        // self.closeDialog();
      });
    },

    /**
     * 受注希望キャンセルリクエストを送信する。
     */
    executeOrderApplicantCancelRequest() {
      const self = this;
      this.postOrderApplicantCancel({
        provisionalOrderCardId: this.record.id
      }).then(value => {
        self.initForm(value.data.data);
        // self.closeDialog();
      });
    },

    /**
     * 正式受注リクエストを送信する。
     */
    executeOrderFormalRequest() {
      const self = this;
      this.saveRecord(this.setTranData(), this.$config.urls.postProvisionalOrderRegisterFormalOrder).then(
        value => {
          self.initForm(value.data.data);
          self.$refs.EditDialog.closeDialog();
        }
      );
    },

    /**
     * 失注登録確認ダイアログで、登録後のコールバック処理
     * @param data
     * @returns {Promise<void>}
     */
    async onSavedLostOrderStatus(data) {
      this.initForm(data);
    },

    /**
     * 失注キャンセルリクエストを送信する。
     */
    executeOrderLossCancelRequest() {
      const self = this;
      this.saveRecord(
        {
          provisionalOrderCardId: this.record.id
        },
        this.$config.urls.postProvisionOrderLossCancel
      ).then(value => {
        self.initForm(value.data.data);
      });
    },

    /**
     * 受注登録中に変更するリクエストを送信する。
     */
    executeCreatingOrderRequest() {
      const self = this;
      this.saveRecord(
        {
          provisionalOrderCardId: this.record.id
        },
        this.$config.urls.postProvisionalOrderCreatingOrder
      ).then(value => {
        console.log(value.data.data);

        self.initForm(value.data.data);
      });
    },

    /**
     * 受注登録中キャンセルリクエストを送信する。
     */
    executeCreatingOrderCancelRequest() {
      const self = this;
      this.saveRecord(
        {
          provisionalOrderCardId: this.record.id
        },
        this.$config.urls.postProvisionalOrderCreatingOrderCancel
      ).then(value => {
        console.log(value.data.data);

        self.initForm(value.data.data);
      });
    },
    /**
     * 正式受注登録ダイアログを開きます。
     */
    async openGeneralOrderEditDialog() {
      // this.$refs.generalOrderEditDialog.openDialog(manualOrder);

      try {
        await this.save({ skipLoading: true });

        // 正式受注前のValidate
        await this.saveRecord(
          this.setTranData(),
          this.$config.urls.postProvisionalOrderRegisterFormalOrderValidate,
          { skipLoading: true }
        );

        this.$refs.orderFormalConfirm.openDialog();
      } catch (error) {
        // バリデーションエラーなどの場合は何もしない（エラーメッセージは既に表示されている）
        // console.warn(error.response.data.message);
      }
    },
    getProvisionalOrderStatusTypeLabel(code) {
      return Enum.Utils.findLabel(code, Enum.ProvisionalOrderStatusType);
    }
  }
};
</script>
